import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { DEFAULT_CONTENT } from "@/constants/content";

export function useSectionContent(key) {
  const { data } = useQuery({
    queryKey: ["content"],
    queryFn: async () => (await api.get("/content")).data,
    staleTime: 60_000,
  });
  return { ...(DEFAULT_CONTENT[key] || {}), ...((data && data[key]) || {}) };
}
